import NotificationForm from "./NotificationForm";

export default NotificationForm;
